import { Handle, Position, useReactFlow } from "@xyflow/react";
import { useState } from "react";
import { Trash } from "react-bootstrap-icons";
import { useTrashNode } from "./commons/trashNode";
import { FlowHandle } from "./commons/flowHandle";

export default function CustomCallTransferNode({ id, data }) {
  const { setNodes, setEdges } = useReactFlow();
  const trashNode = useTrashNode();

  // --- stop reactflow from hijacking input clicks ---
  const stopPropagation = (e) => e.stopPropagation();

  const [settings, setSettings] = useState(
    data.settings || {
      routingType: 1,
      routingValue: "",
      summarizeCaseDescription: false,
      announcementForBusiness:
        "Caller is waiting over a call. Whenever you are ready",
      announcementForCaller:
        "Hold on while I connect you with the business.",
    }
  );

  const [transitions, setTransitions] = useState(
    data.transitions || [
      { id: `transition-${id}-1`, value: "If Failed" },
    ]
  );

  return (
    <dl className="mt-3" style={{ width: "290px" }}>
      {/* Left handle for incoming flow */}
      <FlowHandle type="target" position={Position.Left} />

      <div className="card shadow-sm border">
        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center py-2 bg-light border-bottom">
          <h6 className="mb-0 fw-semibold text-primary">Call Transfer</h6>
          <button
            onClick={(e) => trashNode(e, id)}
            className="btn btn-sm btn-light text-danger p-1"
            title="Delete Node"
          >
            <Trash size={18} />
          </button>
        </div>

        {/* BODY */}
        <div className="card-body p-3">
          {/* Routing Value */}
          <div className="mb-3">
            <label className="form-label small fw-medium text-muted mb-1">
              Routing Value
            </label>
            <input
              type="text"
              onMouseDown={stopPropagation}
              value={settings.routingValue}
              onChange={(e) =>
                setSettings({ ...settings, routingValue: e.target.value })
              }
              placeholder="Enter routing value"
              className="form-control form-control-sm"
            />
          </div>

          {/* Announcement for Business */}
          <div className="mb-3">
            <label className="form-label small fw-medium text-muted mb-1">
              Announcement (Business)
            </label>
            <textarea
              rows={2}
              onMouseDown={stopPropagation}
              value={settings.announcementForBusiness}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  announcementForBusiness: e.target.value,
                })
              }
              placeholder="Message for business"
              className="form-control form-control-sm"
              style={{ resize: "vertical" }}
            />
          </div>

          {/* Announcement for Caller */}
          <div className="mb-3">
            <label className="form-label small fw-medium text-muted mb-1">
              Announcement (Caller)
            </label>
            <textarea
              rows={2}
              onMouseDown={stopPropagation}
              value={settings.announcementForCaller}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  announcementForCaller: e.target.value,
                })
              }
              placeholder="Message for caller"
              className="form-control form-control-sm"
              style={{ resize: "vertical" }}
            />
          </div>

          {/* Transitions */}
          <div>
            <label className="form-label small fw-medium text-muted mb-2">
              Transitions
            </label>
            <div className="d-flex flex-column gap-2">
              {transitions.map((item) => (
                <div key={item.id} className="position-relative d-flex align-items-center">
                  {/* Right handle for next node connection */}
                  <FlowHandle
                    type="source"
                    position={Position.Right}
                    id={item.id}
                    style={{
                      right: "-8px",
                      background: "#0d6efd",
                      width: "8px",
                      height: "8px",
                    }}
                  />

                  <input
                    type="text"
                    onMouseDown={stopPropagation}
                    value={item.value}
                    onChange={(e) => {
                      const updated = transitions.map((t) =>
                        t.id === item.id
                          ? { ...t, value: e.target.value }
                          : t
                      );
                      setTransitions(updated);
                    }}
                    className="form-control form-control-sm"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </dl>
  );
}
